/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OsisRuleBulkUpdateRequest,
    OsisRuleBulkUpdateRequestFromJSON,
    OsisRuleBulkUpdateRequestToJSON,
    OsisRuleDelete,
    OsisRuleDeleteFromJSON,
    OsisRuleDeleteToJSON,
    OsisRuleListConfiguration,
    OsisRuleListConfigurationFromJSON,
    OsisRuleListConfigurationToJSON,
    OsisRuleListItemPaginationWrapper,
    OsisRuleListItemPaginationWrapperFromJSON,
    OsisRuleListItemPaginationWrapperToJSON,
    OsisRuleQuery,
    OsisRuleQueryFromJSON,
    OsisRuleQueryToJSON,
    OsisRuleState,
    OsisRuleStateFromJSON,
    OsisRuleStateToJSON,
    OsisRuleStateResponse,
    OsisRuleStateResponseFromJSON,
    OsisRuleStateResponseToJSON,
} from '../models';

export interface ApiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPostRequest {
    osisRuleBulkUpdateRequest: OsisRuleBulkUpdateRequest;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDeleteRequest {
    osisRuleDelete: Array<OsisRuleDelete>;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleListListPostRequest {
    osisRuleQuery?: OsisRuleQuery;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPostRequest {
    osisRuleState: Array<OsisRuleState>;
}

/**
 * no description
 */
export class OsisRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPostRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPostRequest): Promise<runtime.ApiResponse<Array<OsisRuleStateResponse>>> {
        if (requestParameters.osisRuleBulkUpdateRequest === null || requestParameters.osisRuleBulkUpdateRequest === undefined) {
            throw new runtime.RequiredError('osisRuleBulkUpdateRequest','Required parameter requestParameters.osisRuleBulkUpdateRequest was null or undefined when calling apiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleList/BulkUpdateOsis`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OsisRuleBulkUpdateRequestToJSON(requestParameters.osisRuleBulkUpdateRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OsisRuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPost(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPostRequest): Promise<Array<OsisRuleStateResponse>> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDeleteRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDeleteRequest): Promise<runtime.ApiResponse<Array<OsisRuleStateResponse>>> {
        if (requestParameters.osisRuleDelete === null || requestParameters.osisRuleDelete === undefined) {
            throw new runtime.RequiredError('osisRuleDelete','Required parameter requestParameters.osisRuleDelete was null or undefined when calling apiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleList/DeleteRuleBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.osisRuleDelete.map(OsisRuleDeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OsisRuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDelete(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDeleteRequest): Promise<Array<OsisRuleStateResponse>> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<OsisRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleList/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OsisRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListGetListConfigurationGet(): Promise<OsisRuleListConfiguration> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListListPostRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListListPostRequest): Promise<runtime.ApiResponse<OsisRuleListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OsisRuleQueryToJSON(requestParameters.osisRuleQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OsisRuleListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListListPost(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListListPostRequest): Promise<OsisRuleListItemPaginationWrapper> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPostRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<OsisRuleStateResponse>>> {
        if (requestParameters.osisRuleState === null || requestParameters.osisRuleState === undefined) {
            throw new runtime.RequiredError('osisRuleState','Required parameter requestParameters.osisRuleState was null or undefined when calling apiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.osisRuleState.map(OsisRuleStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OsisRuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPost(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPostRequest): Promise<Array<OsisRuleStateResponse>> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
